export default "__VITE_ASSET__CKRPvwdm__"